<template>
  <div class="wrap">
    <!-- 头部 -->
    <headTop :toggle="lineIndex"></headTop>
    <!-- 中间内容 -->
    <div class="specialistContent">
      <div>
        <div class="contentTitle" style="padding: 0.1em 5em">
          <div class="line"></div>
          <img src="@/assets/image/aboutUs/aboutUsBc.png" alt />
          <div class="titleBcImg">
            <span>{{ mode.name }}</span>
            <span class="eng" @click="goToEnterPrise(mode.enterpriseId)">{{
              mode.enterpriseName
            }}</span>
          </div>
          <div class="line"></div>
        </div>
        <div class="content" style="padding: 0em 5em">
          <div
            v-for="(item, index) in contentList"
            :key="index"
            class="content-inner"
          >
            <div class="content-title" v-if="item">
              {{
                index == 0
                  ? "背景介绍"
                  : index == 1
                  ? "实施思路"
                  : index == 2
                  ? "项目亮点"
                  : ""
              }}
            </div>
            <div v-if="item" v-html="item" class="content-text"></div>
            <!-- <div v-else class="content-text-noData">暂无数据</div> -->
          </div>
          <div class="compontentBox" v-if="imgBoxList && imgBoxList.length > 0">
            <imgBox :list="imgBoxList"></imgBox>
          </div>
        </div>
        <div class="zixun-wrapper">
          <div class="zixun-top">
             <img src="@/assets/image/index/gif-1.gif" alt />
          </div>
          <div class="zixun-bottom">
            
        <div class="zixun" @click="goToConsultation(mode.id)">
          <img src="@/assets/image/index/1.png" alt />
          <span>在线咨询</span>
        </div>
          </div>

        </div>
        <!-- <div class="zixun" @click="goToConsultation(mode.id)">
          <img src="@/assets/image/index/1.png" alt />
          <span>咨询</span>
        </div> -->
      </div>
      <div class="footer">
        <footCode></footCode>
      </div>
    </div>
  </div>
</template>
<script>
import footCode from "../../components/footCode";
import headTop from "../../components/HeadTop";
import imgBox from "../../components/imgBoxAndDialog";
export default {
  name: "caseDetail",
  components: {
    footCode,
    headTop,
    imgBox,
  },

  data() {
    return {
      id: "",
      mode: {},
      lineIndex: null,
      // imgBoxList: [],
    };
  },
  computed: {
    // 输出三标题的内容
    // 拆分富文本后如只有空标签则只返回暂无数据
    // 三标题下内容不输出图片
    contentList() {
      if (this.mode) {
        var data = [];
        if (this.mode.backgroundContent) {
          var bgText = this.getText(
            this.mode.backgroundContent.replace(/<\/?(img)[^>]*>/gi, "")
          );
          if (this.isNull(bgText)) {
            data.push("");
          } else {
            let text1 = this.mode.backgroundContent.replace(
              /<\/?(img)[^>]*>/gi,
              ""
            );
            // let text2 = text1.replace(/\r\n]/g, "");
            data.push(text1);
          }
        } else {
          data.push(this.mode.backgroundContent);
        }
        if (this.mode.ideaContent) {
          var ideaText = this.getText(
            this.mode.ideaContent.replace(/<\/?(img)[^>]*>/gi, "")
          );
          if (this.isNull(ideaText)) {
            data.push("");
          } else {
            data.push(this.mode.ideaContent.replace(/<\/?(img)[^>]*>/gi, ""));
          }
        } else {
          data.push(this.mode.ideaContent);
        }

        if (this.mode.sparkleContent) {
          var sparkleText = this.getText(
            this.mode.sparkleContent.replace(/<\/?(img)[^>]*>/gi, "")
          );
          if (this.isNull(sparkleText)) {
            data.push("");
          } else {
            data.push(
              this.mode.sparkleContent.replace(/<\/?(img)[^>]*>/gi, "")
            );
          }
        } else {
          data.push(this.mode.sparkleContent);
        }
        return data;
      }
    },
    // 拆分富文本获取轮播图片
    imgBoxList() {
      if (this.mode) {
        if (this.mode.backgroundContent) {
          var a = this.mode.backgroundContent
            .split("img")
            .map((item) => {
              if (item.includes("src"))
                return item.split("alt")[0].slice(6, -2);
            })
            .splice(1);
        } else {
          var a = [];
        }

        if (this.mode.ideaContent) {
          var b = this.mode.ideaContent
            .split("img")
            .map((item) => {
              if (item.includes("src"))
                return item.split("alt")[0].slice(6, -2);
            })
            .splice(1);
          // console.log("ideaContent", b);
        } else {
          var b = [];
        }

        if (this.mode.sparkleContent) {
          var c = this.mode.sparkleContent
            .split("img")
            .map((item) => {
              if (item.includes("src"))
                return item.split("alt")[0].slice(6, -2);
            })
            .splice(1);
          console.log("sparkleContent", c);
        } else {
          var c = [];
        }
        var imgArray = [...a, ...b, ...c];
        // console.log("imgArray", imgArray);
        return imgArray;
      }
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.lineIndex = Number(this.$route.query.index);
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.ajaxUtil({
        method: "get",
        // url: '/apiAjax/api/home/index',
        url:
          this.$store.state.axiosUrl +
          `/api/home/v2/getProductById?productId=${this.id}`,
      }).then((res) => {
        this.mode = res.data;
      });
    },
    goToEnterPrise(id) {
      this.$router.push({
        path: "/enterprise/enterpriseDetail",
        query: { id },
      });
    },
    goToConsultation(pid) {
      if (!pid) pid = 0;
      let token = sessionStorage.getItem("token");
      if (!token) {
        this.$message.error("请先登录");
        return false;
      } else {
        this.$store.commit("changechatShow", true);
        this.$store.commit("changePid", pid);
      }
    },
    getText(str) {
      return str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "");
    },
    isNull(str) {
      if (str == "") return true;
      var regu = "^[ ]+$";
      var re = new RegExp(regu);
      return re.test(str);
    },
  },
};
</script>
<style scoped lang="less">
.wrap {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  min-width: 12.8em;
  .zixun-wrapper{
    position: fixed;
    top: 1.3em;
    right: 0;
  //   	animation: myFrame1 2s linear infinite;
	// -webkit-animation: myFrame1 2s linear infinite;
    // border-radius: 50%;
     border-radius: 5px 0px 0px 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .zixun-top{
    height: 150px;
    margin-bottom:10px;
  }
  .zixun-bottom{
    width: 140px;
  }
  .zixun {
    background: #2579BF;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding: 0.1em 0.10em 0.1em 0.10em;
    width: 1.4em;
    height: 0.4em;
    margin-right: 0.58em;
    cursor: pointer;
    img {
      height: 0.2em;
      width: 0.25em;
    }
    span {
      font-size: 0.2em;
      text-align: center;
      color: #fff;
      margin-left:8px ;
    }
  }
  @keyframes myFrame1{
  // 20%{
  //   //  width:2.1em;
  //   // height: 2.5em;
	// 	transform-origin: center;
	// 	box-shadow: -1px 1px 20px red;
  //   // border:1px solid grey;
  //   // padding: 0px 0px 0px 50px;
  //   // border-radius: 50%;
	// }  
	50%{
		transform-origin: center;
		box-shadow: -1px 1px 20px red;
    //  width:2.2em;
    // height: 2.6em;
		// transform: translate(-8%);
		// transform-origin: center;
		// box-shadow: -1px 1px 20px red;
    // border:1px solid #2579bf;
    // padding: 0px 0px 0px 50px;
    // border-radius: 50%;
	}


}

  .specialistContent {
    display: flex;
    flex-direction: column;
    // flex: 1;
    min-height: 100vh;
    justify-content: space-between;
    .titlePosition {
      font-size: 0.15em;
      display: flex;
      justify-content: flex-end;
      width: 100%;
      color: #666;
    }
    .contentTitle {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
      .titleBcImg {
        height: 78px;
        background-size: cover;
        margin: 0 1em;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 0.22em;
        position: relative;
        margin-top: 1em;
        white-space: nowrap;
        .eng {
          text-align: center;
          width: 249px;
          height: 18px;
          font-size: 15px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #2579bf;
          bottom: 0;

          cursor: pointer;
        }
      }
      .line {
        width: 250px;
        height: 1px;
        background-color: #999;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      margin-top: 0px;
      margin-bottom: 80px;
      width: 100%;
      .imgBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: 0.3em;
      }
      /deep/.infoContent {
        font-size: 18px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #333333;
        line-height: 28px;
        img {
          display: none;
        }
        br {
          display: none;
        }
      }
      .content-inner {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-content: center;
        flex-direction: column;
        overflow-wrap: break-word;
        word-break: break-word;
        word-wrap: break-word;
        .content-title {
          text-align: left;
          font-size: 0.2em;
          font-weight: 600;
          color: rgb(66, 122, 227);
          margin-bottom: 30px;
          margin-left: 20px;
        }
        .content-text {
          width: 100%;
          height: 100%;
          font-size: 0.18em;
          color: rgb(107, 107, 111);
          margin-bottom: 20px;
          font-weight: 500;
          line-height: 180%;
          text-indent:30px;
        }
        // .content-text:before {
          
        // }
        .content-text-noData {
          width: 100%;
          height: 100%;
          overflow: hidden;
          display: flex;
          justify-content: center;
          font-size: 0.18em;
          color: rgb(107, 107, 111);
          margin-bottom: 20px;
          font-weight: 500;
          line-height: 100%;
        }
      }
    }
  }
}
.buttonFont {
  font-size: 1.625em;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  letter-spacing: 0.3125em;
  color: #ffffff;
}
.buttonCloumn {
  text-align: center;
  margin-top: 60px;
  margin-bottom: 90px;
}
.compontentBox {
  width: 100%;
  font-size: 0.15em;
}
</style>



// WEBPACK FOOTER //
// src/views/case/caseDetail.vue